import {createReducer, on} from '@ngrx/store';
import {TeamRegisterState} from './team-register.state';
import {TeamRegisterActions} from '@team/pages/register/store/team-register.actions-type';
import {EAppType} from '@shared/models/AppType.enum';

export const initialState: TeamRegisterState = {
  currentApp: EAppType.Team,
  isLoading: false,
  isLogging: false,
  isLogged: false,
  currentTenant: undefined
};

export const teamRegisterStore = createReducer(
  initialState,
  on(TeamRegisterActions.initRegistrationGuest, (state, { isLoadingId }) => ({
    ...state,
    isLoading: true,
    isLoadingId,
  })),
  on(TeamRegisterActions.initRegistrationGuestDialogClose, (state) => ({
    ...state,
    isLoading: false,
    isLoadingId: '',
  })),
  on(TeamRegisterActions.initRegistrationGuestDialogClose, (state) => ({
    ...state,
    isLoading: false,
    isLoadingId: '',
  })),
  on(TeamRegisterActions.checkInvitationCode, (state, { isLoadingId }) => ({
    ...state,
    isLoading: true,
  })),
  on(TeamRegisterActions.checkInvitationCodeSuccess, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(TeamRegisterActions.checkInvitationCodeFail, (state) => ({
    ...state,
    isLoading: false
  })),
  on(TeamRegisterActions.registerGuestPinRequest, (state, { isLoadingId }) => ({
    ...state,
    isLoading: true,
    isLoadingId: isLoadingId!,
  })),
  on(TeamRegisterActions.registerGuestPinDialog, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(TeamRegisterActions.registerGuestPinRequestSuccess, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(TeamRegisterActions.registerGuestPinRequestFail, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(TeamRegisterActions.registerGuestAsUser, (state, { isLoadingId }) => ({
    ...state,
    isLoading: true,
    isLoadingId: isLoadingId!,
  })),
  on(TeamRegisterActions.registerGuestAsUserSuccess, (state) => ({
    ...state,
    isLoading: false,
    isLogging: true,
  })),
  on(TeamRegisterActions.registerGuestAsUserFail, (state) => ({
    ...state,
    isLoading: false,
  })),

  on(TeamRegisterActions.checkInvitationIdentity, (state, { isLoadingId }) => ({
    ...state,
    isLoading: true,
    isLoadingId: isLoadingId!,
  })),
  on(TeamRegisterActions.checkInvitationIdentitySuccess, (state, { tenantId }) => ({
    ...state,
    currentTenant: {
      tenantId,
    },
    isLoading: false,
  })),
  on(TeamRegisterActions.checkInvitationIdentityFail, (state) => ({
    ...state,
    isLoading: false,
  }))
)
